module.exports = __webpack_public_path__ + "img/self2.8a265dd9.jpg";